import _ from 'lodash';
import { FC, ReactNode, useEffect, useRef } from 'react';

import { useLocalize } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';

import { useGrowthPathContext } from '../contexts/GrowthPathContext';
import { GrowthPathJobCompetency } from '../types';

type Props = {
	jobCompetencies: Array<Partial<GrowthPathJobCompetency>>;
	children: ReactNode;
	data: graphql.UserCompetenciesQuery | graphql.JobTitleCompetenciesQuery | undefined;
};

const LabelQueryWrapper: FC<Props> = ({ jobCompetencies, children, data }) => {
	const hasMounted = useRef(false);
	const { localize } = useLocalize();

	const { setLabelID, labelID, jobTitleID } = useGrowthPathContext();

	useEffect(() => {
		const labels = _.sortBy(
			_.uniqBy(
				jobCompetencies.flatMap((jobCompetency) => jobCompetency.competency?.label).filter(Boolean),
				'id',
			),
			(label) => localize(label!.title).text,
		);

		if (labels.length === 0) {
			setLabelID('unlabeled');
			return;
		}

		if (labels.length > 0 && labels[0]?.id) {
			setLabelID(labels[0]?.id);
			return;
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [jobTitleID, data]);

	useEffect(() => {
		if (hasMounted.current) {
			if (labelID) {
				setLabelID(labelID);
				return;
			}
		}

		hasMounted.current = true;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [labelID]);

	return children;
};
export default LabelQueryWrapper;
